<template>
  <div class="container" >
    <div v-for="format in formats" :key="api.measure.uniqueName(format.measure)" >
      <el-form-item :label="api.measure.name(format.measure)" >
        <el-input v-model="format.format" @change="() => emit()" />
      </el-form-item>
    </div>
  </div>
</template>

<script>
import customGraphApiAware from './mixins/customGraphApiAware'

export default {
  props: {
    value: {
      default: null
    },
    measures: {
      required: true,
      type: Array
    }
  },
  mixins: [
    customGraphApiAware
  ],
  watch: {
    measures: {
      immediate: true,
      handler (measures) {
        this.formats = measures.map(m => {
          const format = this.values.find(v => v.measure === this.api.measure.uniqueName(m))
          return Object.assign({ measure: m, format: format ? format.format : null })
        })
      }
    },
    value: {
      immediate: true,
      handler (value) {
        this.values = value || []
        this.formats.forEach(f => {
          const v = value.find(v => v.measure === this.api.measure.uniqueName(f.measure))
          f.format = v ? v.format : null
        })
      }
    }
  },
  data () {
    return {
      formats: [],
      values: []
    }
  },
  methods: {
    emit () {
      this.$emit('input', this.formats.map(f => Object.assign({
        measure: this.api.measure.uniqueName(f.measure),
        format: f.format
      })))
      this.$emit('change')
    }
  }
}
</script>

<style scoped>
.el-form-item >>> .el-input {
    margin: 0 !important;
}
.container {
    margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// node_modules/macarons-graphs-front/src/FormatConfig.vue